import { useEffect } from "react";

export function useSecureUrl() {
  useEffect(() => {
    if (window.location.protocol !== 'https:' && process.env.NODE_ENV === 'production') {
      window.location.replace(`https:${window.location.href.substring(window.location.protocol.length)}`);
    }
  }, []);
}